import React from 'react'
import Layout from '../components/Layout'

const privacy = () => {
  return (
    <Layout seoTitle="Aviso de Privacidad">
      <section className="section cont-area">
        <h3>Aviso de Privacidad</h3>
        <p>
          En cumplimiento con lo establecido por la Ley Federal de Protección de
          Datos Personales en Posesión de Particulares, Turista.com.mx S.A. de
          C.V. con domicilio en Av. Nizuc Mza 2 Lt 29 Casa 14 SM 17, Cancún,
          Quintana Roo C.P. 77500, procurará que el tratamiento de sus datos
          personales o sensibles, entendidos todos aquellos datos que puedan
          identificarle, tal como su nombre y apellido, número de teléfono,
          dirección postal y de correo electrónico, la información sobre su
          tarjeta de crédito, etc; ("Datos"), sea controlado a efecto de
          proporcionar privacidad y el derecho a la autodeterminación
          informativa de los mismos, sugerimos la lectura del presente aviso ya
          que la aportación de datos a Turista.com.mx por cualquier medio,
          constituye la aceptación del presente aviso de privacidad.
        </p>

        <p>
          Sus datos personales serán utilizados con las siguientes finalidades:
          Permitirle interacción con los módulos públicos de nuestra red,
          enviarle artículos promocionales y en algunos casos publicidad,
          permitirle interacción con otros usuarios.
        </p>

        <p>
          Cuando hace una reservación en Línea mediante nuestros diversos
          asociados de viajes, ellos recaban sus datos y cuentan con sus propios
          avisos de privacidad.
        </p>

        <h4>Uso de tecnologías de rastreo en nuestro portal de internet</h4>
        <p>
          Le informamos que en nuestra página de internet utilizamos cookies,
          web beacons u otras tecnologías, a través de las cuales es posible
          monitorear su comportamiento como usuario de internet, así como
          brindarle un mejor servicio y experiencia al navegar en nuestra
          página. Los datos personales que obtenemos de estas tecnologías de
          rastreo son los siguientes:
        </p>
        <p>Idioma preferido por el usuario</p>
        <p>
          Estas cookies, web beacons y otras tecnologías pueden ser
          deshabilitadas. Para conocer cómo hacerlo, consulte el menú de ayuda
          de su navegador. Tenga en cuenta que, en caso de desactivar las
          cookies, es posible que no pueda acceder a ciertas funciones
          personalizadas en nuestros sitio web.
        </p>
        <h4>¿Cómo puede conocer los cambios en este aviso de privacidad?</h4>
        <p>
          El presente aviso de privacidad puede sufrir modificaciones, cambios o
          actualizaciones derivadas de nuevos requerimientos legales; de
          nuestras propias necesidades por los productos o servicios que
          ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro
          modelo de negocio, o por otras causas. Nos comprometemos a mantener
          actualizado este aviso de privacidad sobre los cambios que pueda
          sufrir y siempre podrá consultar las actualizaciones que existan en el
          sitio web solito.com.
        </p>
        <p>Última actualización de este aviso de privacidad: 18/02/2022</p>
      </section>
    </Layout>
  )
}

export default privacy
